import { Injectable, OnDestroy, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import Intercom, { shutdown as intercomShutdown } from '@intercom/messenger-js-sdk';
import { EnvironmentService } from '@app/core/services/environment.service';

export interface IntercomSecureSettings {
  app_id: string;
  intercom_user_jwt: string;
  [key: string]: unknown;
}

@Injectable({ providedIn: 'root' })
export class IntercomService implements OnDestroy {
  private readonly http = inject(HttpClient);
  private readonly environment = inject(EnvironmentService);
  private readonly API_URL = `${this.environment.apiBaseUrl}/intercomAPI/Token`;
  readonly #booted = signal(false);

  async boot(nonSensitiveData: Omit<IntercomSecureSettings, 'app_id' | 'intercom_user_jwt'> = {}): Promise<void> {
    if (this.#booted()) {
      return;
    }

    try {
      const tokenResponse = await this.fetchIntercomToken();
      if (!tokenResponse) {
        return;
      }

      const settings: IntercomSecureSettings = {
        app_id: this.environment.intercomId,
        intercom_user_jwt: tokenResponse,
        ...nonSensitiveData,
      };

      Intercom(settings);
      this.#booted.set(true);
    } catch (error) {
      console.error('Ocurrió un error durante la inicialización de Intercom:', error);
    }
  }

  shutdown(): void {
    if (this.#booted()) {
      intercomShutdown();
      this.#booted.set(false);
    }
  }

  ngOnDestroy(): void {
    this.shutdown();
  }

  private fetchIntercomToken(): Promise<string | null> {
    return firstValueFrom(this.http.get<string>(this.API_URL));
  }
}


